function Privacy() {
  return (
    <section className="generalContainer">
      <div className="generalBackground light-bg privacyPolicy">
        <h2 className="section-title">Privacy Policy</h2>
        <p>
          <strong>POLITIQUE DE CONFIDENTIALITÉ</strong>
        </p>
        <p>
          <strong>DU SITE&nbsp;: </strong>
        </p>
        <p>
          <strong>
            <span id="span_id_nom_du_site">Z-Team</span>{' '}
          </strong>
        </p>
        <br />
        <p>
          <strong>
            ARTICLE 1&nbsp;: PRÉAMBULE
            <br />
          </strong>
        </p>
        <p>
          Cette politique de confidentialité s'applique au site&nbsp;:{' '}
          <span id="span_id_nom_du_site">Z-Team</span>. <br />
        </p>
        <p>
          La présente politique de confidentialité a pour but d'exposer aux
          utilisateurs du site&nbsp;:
        </p>
        <ul>
          <li>
            La manière dont sont collectées et traitées leurs données à
            caractère personnel. Doivent être considérées comme données
            personnelles toutes les données étant susceptibles d'identifier un
            utilisateur. Il s'agit notamment du prénom et du nom, de l'âge, de
            l'adresse postale, l'adresse mail, la localisation de l'utilisateur
            ou encore son adresse IP&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Quels sont les droits des utilisateurs concernant ces données&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Qui est responsable du traitement des données à caractère personnel
            collectées et traitées&nbsp;;
          </li>
        </ul>
        <ul>
          <li>A qui ces données sont transmises&nbsp;;</li>
        </ul>
        <ul>
          <li>
            Eventuellement, la politique du site en matière de fichiers
            "cookies".
          </li>
        </ul>
        <p>
          <br />
          Cette politique de confidentialité complète les mentions légales et
          les Conditions Générales d'Utilisation que les utilisateurs peuvent
          consulter à l'adresse ci-après&nbsp;:
        </p>
        <p>
          <span id="span_id_url_cgu">www.z-team.herokuapp.com</span>
        </p>
        <p>
          <span>
            <br />
          </span>
          <strong>
            ARTICLE 2&nbsp;: PRINCIPES GÉNÉRAUX EN MATIÈRE DE COLLECTE ET DE
            TRAITEMENT DE DONNÉES
          </strong>
          <br />
        </p>
        <p>
          Conformément aux dispositions de l'article 5 du Règlement européen
          2016/679, la collecte et le traitement des données des utilisateurs du
          site respectent les principes suivants&nbsp;:
        </p>
        <ul>
          <li>
            Licéité, loyauté et transparence&nbsp;: les données ne peuvent être
            collectées et traitées qu'avec le consentement de l'utilisateur
            propriétaire des données. A chaque fois que des données à caractère
            personnel seront collectées, il sera indiqué à l'utilisateur que ses
            données sont collectées, et pour quelles raisons ses données sont
            collectées&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Finalités limitées&nbsp;: la collecte et le traitement des données
            sont exécutés pour répondre à un ou plusieurs objectifs déterminés
            dans les présentes conditions générales d'utilisation&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Minimisation de la collecte et du traitement des données&nbsp;:
            seules les données nécessaires à la bonne exécution des objectifs
            poursuivis par le site sont collectées&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Conservation des données réduites dans le temps&nbsp;: les données
            sont conservées pour une durée limitée, dont l'utilisateur est
            informé. Lorsque cette information ne peut pas être communiquée,
            l'utilisateur est informé des critères utilisés pour déterminer la
            durée de conservation&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Intégrité et confidentialité des données collectées et
            traitées&nbsp;: le responsable du traitement des données s'engage à
            garantir l'intégrité et la confidentialité des données collectées.
            <br />
          </li>
        </ul>
        <p>
          Afin d'être licites, et ce conformément aux exigences de l'article 6
          du règlement européen 2016/679, la collecte et le traitement des
          données à caractère personnel ne pourront intervenir que s'ils
          respectent au moins l'une des conditions ci-après énumérées&nbsp;:
        </p>
        <ul>
          <li>L'utilisateur a expressément consenti au traitement&nbsp;;</li>
        </ul>
        <ul>
          <li>
            Le traitement est nécessaire à la bonne exécution d'un
            contrat&nbsp;;
          </li>
        </ul>
        <ul>
          <li>Le traitement répond à une obligation légale&nbsp;;</li>
        </ul>
        <ul>
          <li>
            Le traitement s'explique par une nécessité liée à la sauvegarde des
            intérêts vitaux de la personne concernée ou d'une autre personne
            physique&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Le traitement peut s'expliquer par une nécessité liée à l'exécution
            d'une mission d'intérêt public ou qui relève de l'exercice de
            l'autorité publique&nbsp;;
          </li>
        </ul>
        <ul>
          <li>
            Le traitement et la collecte des données à caractère personnel sont
            nécessaires aux fins des intérêts légitimes et privés poursuivis par
            le responsable du traitement ou par un tiers.
          </li>
        </ul>
        <p>
          <br />
          <strong>
            ARTICLE 3&nbsp;: DONNÉES À CARACTÈRE PERSONNEL COLLECTÉES ET
            TRAITÉES DANS LE CADRE DE LA NAVIGATION SUR LE SITE
            <br />
          </strong>
        </p>
        <p>
          <strong>A. </strong>DONNÉES COLLECTÉES ET TRAITÉES ET MODE DE COLLECTE
        </p>
        <p>
          Les données à caractère personnel collectées sur le site{' '}
          <span id="span_id_nom_du_site_internet">Z-Team</span> sont les
          suivantes&nbsp;:
        </p>
        <p>
          <span id="span_id_liste_donnees_collectees">
            Adresse email
            <br />
            Identifiants de connexion
          </span>
        </p>
        <p>
          Ces données sont collectées lorsque l'utilisateur effectue l'une des
          opérations suivantes sur le site&nbsp;:
        </p>
        <p>
          <span id="span_id_operations_collectes_donnees">
            Lorsque l'utilisateur utilise le formulaire de contact
          </span>{' '}
        </p>
        <p>
          Le responsable du traitement conservera dans ses systèmes
          informatiques du site et dans des conditions raisonnables de sécurité
          l'ensemble des données collectées pour une durée de&nbsp;:{' '}
          <span id="span_id_duree_conservation_donnees">3 ans</span>.
        </p>
        <p>
          La collecte et le traitement des données répondent aux finalités
          suivantes&nbsp;:
        </p>
        <p>
          <span>
            <span id="span_id_finalite_traitement_donnees" className="encours">
              <span className="variable_vide">________</span>
            </span>
          </span>
        </p>
        <p>
          Les traitements de données effectués sont fondés sur les bases légales
          suivantes&nbsp;:
        </p>
        <p>
          <span id="span_id_bases_legales">
            <span className="variable_vide">________</span>
          </span>
        </p>

        <p>
          <strong>B.</strong> TRANSMISSION DES DONNÉES A DES TIERS
        </p>

        <p>
          Les données à caractère personnel collectées par le site ne sont
          transmises à aucun tiers, et ne sont traitées que par l'éditeur du
          site. <br />
        </p>
        <p>
          <strong>C. </strong>HÉBERGEMENT DES DONNÉES
        </p>
        <p>
          Le site <span id="span_id_nom_du_site_internet">Z-Team</span> est
          hébergé par&nbsp;:{' '}
          <span id="span_id_denomination_sociale_de_l_hebergeur">
            <span className="variable_vide">________</span>
          </span>
          , dont le siège est situé à l'adresse ci-après&nbsp;:
        </p>
        <p>
          <span id="span_id_siege_social_de_l_hebergeur">
            <span className="variable_vide">________</span>
          </span>
        </p>
        <p>
          L'hébergeur peut être contacté au numéro de téléphone suivant&nbsp;:{' '}
          <span id="span_id_telephone_de_l_hebergeur">
            <span className="variable_vide">________</span>
          </span>
          .{' '}
        </p>
        <p>
          Les données collectées et traitées par le site sont exclusivement
          hébergées et traitées en France.{' '}
        </p>
        <p>
          <br />
          <strong>
            ARTICLE 4&nbsp;: RESPONSABLE DU TRAITEMENT DES DONNÉES{' '}
          </strong>
        </p>

        <p>
          <strong>A. </strong>LE RESPONSABLE DU TRAITEMENT DES DONNÉES
        </p>
        <p>
          Le responsable du traitement des données à caractère personnel
          est&nbsp;:{' '}
          <span id="span_id_prenom_nom_responsable">
            <span className="variable_vide">________</span>
          </span>
          . Il peut être contacté de la manière suivante&nbsp;:
        </p>
        <p>
          <span id="span_id_methode_contact_rtd">
            <span className="variable_vide">________</span>
          </span>
        </p>
        <p>
          Le responsable du traitement des données est chargé de déterminer les
          finalités et les moyens mis au service du traitement des données à
          caractère personnel. <br />
        </p>
        <p>
          <strong>B. </strong>OBLIGATIONS DU RESPONSABLE DU TRAITEMENT DES
          DONNÉES
        </p>
        <p>
          Le responsable du traitement s'engage à protéger les données à
          caractère personnel collectées, à ne pas les transmettre à des tiers
          sans que l'utilisateur n'en ait été informé et à respecter les
          finalités pour lesquelles ces données ont été collectées.
        </p>

        <p>
          De plus, le responsable du traitement des données s'engage à notifier
          l'utilisateur en cas de rectification ou de suppression des données, à
          moins que cela n'entraîne pour lui des formalités, coûts et démarches
          disproportionnés.
        </p>
        <p>
          Dans le cas où l'intégrité, la confidentialité ou la sécurité des
          données à caractère personnel de l'utilisateur est compromise, le
          responsable du traitement s'engage à informer l'utilisateur par tout
          moyen. <br />
        </p>
        <p>
          <strong>ARTICLE 5&nbsp;: DROITS DE L'UTILISATEUR </strong>
          <br />
        </p>
        <p>
          Conformément à la réglementation concernant le traitement des données
          à caractère personnel, l'utilisateur possède les droits ci-après
          énumérés.
        </p>
        <p>
          Afin que le responsable du traitement des données fasse droit à sa
          demande, l'utilisateur est tenu de lui communiquer&nbsp;: ses prénom
          et nom ainsi que son adresse e-mail, et si cela est pertinent, son
          numéro de compte ou d'espace personnel ou d'abonné.
        </p>
        <p>
          Le responsable du traitement des données est tenu de répondre à
          l'utilisateur dans un délai de 30 (trente) jours maximum.
          <br />
        </p>
        <p>
          <strong>A.</strong> PRÉSENTATION DES DROITS DE L'UTILISATEUR EN
          MATIÈRE DE COLLECTE ET TRAITEMENT DE DONNÉES
        </p>
        <p>
          <em>
            <br />
            a. Droit d'accès, de rectification et droit à l'effacement
          </em>
        </p>
        <p>
          L'utilisateur peut prendre connaissance, mettre à jour, modifier ou
          demander la suppression des données le concernant, en respectant la
          procédure ci-après énoncée&nbsp;:
        </p>
        <p>
          <span id="span_id_procedure_acces_donnees">
            <span className="variable_vide">________</span>
          </span>{' '}
        </p>
        <p>
          S'il en possède un, l'utilisateur a le droit de demander la
          suppression de son espace personnel en suivant la procédure
          suivante&nbsp;:
        </p>
        <p>
          <span id="span_id_procedure_suppression_compte">
            <span className="variable_vide">________</span>
          </span>
          <br />
        </p>
        <p>
          <em>b. Droit à la portabilité des données</em>
        </p>
        <p>
          L'utilisateur a le droit de demander la portabilité de ses données
          personnelles, détenues par le site, vers un autre site, en se
          conformant à la procédure ci-après&nbsp;:
        </p>
        <p>
          <span id="span_id_procedure_portabilite_donnees_personnelles">
            <span className="variable_vide">________</span>
          </span>
        </p>
        <p>
          <br />
          <em>
            c. Droit à la limitation et à l'opposition du traitement des données
          </em>
        </p>
        <p>
          L'utilisateur a le droit de demander la limitation ou de s'opposer au
          traitement de ses données par le site, sans que le site ne puisse
          refuser, sauf à démontrer l'existence de motifs légitimes et
          impérieux, pouvant prévaloir sur les intérêts et les droits et
          libertés de l'utilisateur.
        </p>
        <p>
          Afin de demander la limitation du traitement de ses données ou de
          formuler une opposition au traitement de ses données, l'utilisateur
          doit suivre la procédure suivante&nbsp;:
        </p>
        <p>
          <span id="span_id_procedure_limitation_traitement">
            <span className="variable_vide">________</span>
          </span>
          <br />
        </p>
        <p>
          <em>
            d. Droit de ne pas faire l'objet d'une décision fondée exclusivement
            sur un procédé automatisé
          </em>
        </p>
        <p>
          Conformément aux dispositions du règlement 2016/679, l'utilisateur a
          le droit de ne pas faire l'objet d'une décision fondée exclusivement
          sur un procédé automatisé si la décision produit des effets juridiques
          le concernant, ou l'affecte de manière significative de façon
          similaire.
        </p>
        <p>
          <br />
          <em>e. Droit de déterminer le sort des données après la mort</em>
        </p>
        <p>
          Il est rappelé à l'utilisateur qu'il peut organiser quel doit être le
          devenir de ses données collectées et traitées s'il décède,
          conformément à la loi n°2016-1321 du 7 octobre 2016.
        </p>
        <p>
          <br />
          <em>f. Droit de saisir l'autorité de contrôle compétente</em>
        </p>
        <p>
          Dans le cas où le responsable du traitement des données décide de ne
          pas répondre à la demande de l'utilisateur, et que l'utilisateur
          souhaite contester cette décision, ou, s'il pense qu'il est porté
          atteinte à l'un des droits énumérés ci-dessus, il est en droit de
          saisir la CNIL (Commission Nationale de l'Informatique et des
          Libertés, https://www.cnil.fr) ou tout juge compétent.{' '}
        </p>
        <p>
          <br />
          <strong>
            ARTICLE 6&nbsp;: UTILISATION DES FICHIERS "COOKIES"
            <br />
          </strong>
        </p>
        <p>Le site a éventuellement recours aux techniques de "cookies".</p>
        <p>
          Un "cookie" est un fichier de petite taille (moins de 4 ko), stocké
          par le site sur le disque dur de l'utilisateur, contenant des
          informations relatives aux habitudes de navigation de l'utilisateur.
        </p>
        <p>
          Ces fichiers lui permettent de traiter des statistiques et des
          informations sur le trafic, de faciliter la navigation et d'améliorer
          le service pour le confort de l'utilisateur.
        </p>
        <p>
          Pour l'utilisation de fichiers "cookies" impliquant la sauvegarde et
          l'analyse de données à caractère personnel, le consentement de
          l'utilisateur est nécessairement demandé.
        </p>
        <p>
          Ce consentement de l'utilisateur est considéré comme valide pour une
          durée de 6 (six) mois maximum. A l'issue de cette période, le site
          demandera à nouveau l'autorisation de l'utilisateur pour enregistrer
          des fichiers "cookies" sur son disque dur.
        </p>
        <p>
          <br />
          <em>
            a. Opposition de l'utilisateur à l'utilisation de fichiers "cookies"
            par le site
          </em>
        </p>
        <p>
          Les cookies non essentiels au fonctionnement du site ne sont déposés
          sur le terminal de l'utilisateur qu'après avoir obtenu son
          consentement. L'utilisateur peut retirer son consentement à tout
          moment, de la manière suivante&nbsp;:
        </p>
        <p>
          <span id="span_id_consentement_cookies">
            <span className="variable_vide">________</span>
          </span>
        </p>
        <p>
          De manière plus générale, il est porté à la connaissance de
          l'utilisateur qu'il peut s'opposer à l'enregistrement de ces fichiers
          "cookies" en configurant son logiciel de navigation.
        </p>
        <p>
          Pour information, l'utilisateur peut trouver aux adresses suivantes
          les démarches à suivre afin de configurer son logiciel de navigation
          pour s'opposer à l'enregistrement des fichiers "cookies"&nbsp;:
        </p>
        <ul>
          <li>
            <strong>Chrome</strong>&nbsp;:
            https://support.google.com/accounts/answer/61416?hl=fr
          </li>
        </ul>
        <ul>
          <li>
            <strong>Firefox</strong>&nbsp;:
            https://support.mozilla.org/fr/kb/enable-and-disable-cookies-website-preferences
          </li>
        </ul>
        <ul>
          <li>
            <strong>Safari</strong>&nbsp;:
            https://www.apple.com/legal/privacy/fr-ww/
          </li>
        </ul>
        <ul>
          <li>
            <strong>Internet Explorer</strong>&nbsp;:
            https://support.microsoft.com/fr-fr/help/17442/windows-internet-explorer-delete-manage-cookies
          </li>
        </ul>
        <ul>
          <li>
            <strong>Opera</strong>&nbsp;:
            https://www.opera.com/help/tutorials/security/cookies/
          </li>
        </ul>
        <p>
          <br />
          Dans le cas où l'utilisateur décide de désactiver les fichiers
          "cookies", il pourra poursuivre sa navigation sur le site. Toutefois,
          tout dysfonctionnement du site provoqué par cette manipulation ne
          pourrait être considéré comme étant du fait de l'éditeur du site.
        </p>
        <p>
          <br />
          <em>b. Description des fichiers "cookies" utilisés par le site</em>
        </p>
        <p>
          L'éditeur du site attire l'attention de l'utilisateur sur le fait que
          les cookies suivants sont utilisés lors de sa navigation&nbsp;:
        </p>
        <p>
          <span id="span_id_liste_cookies">
            <span className="variable_vide">________</span>
          </span>{' '}
        </p>
        <p>
          En naviguant sur le site, il est porté à connaissance de l'utilisateur
          que des fichiers "cookies" de tiers peuvent être enregistrés.
        </p>
        <p>Il s'agit plus particulièrement des tiers suivants&nbsp;:</p>
        <p>
          <span id="span_id_tiers_cookies">
            <span className="variable_vide">________</span>
          </span>{' '}
        </p>
        <p>
          De plus, le site intègre des boutons de réseaux sociaux, permettant à
          l'utilisateur de partager son activité sur le site. Des fichiers
          "cookies" de ces réseaux sociaux sont par conséquent susceptibles
          d'être stockés sur l'ordinateur de l'utilisateur lorsqu'il utilise ces
          fonctionnalités.
        </p>
        <p>
          L'attention de l'utilisateur est portée sur le fait que ces sites
          disposent de politiques de confidentialité propres et de conditions
          générales d'utilisation possiblement différentes du site. L'éditeur du
          site invite les utilisateurs à consulter les politiques de
          confidentialité et les conditions générales d'utilisation de ces
          sites.
          <br />
        </p>
        <p>
          <strong>
            ARTICLE 7&nbsp;: CONDITIONS DE MODIFICATION DE LA POLITIQUE DE
            CONFIDENTIALITÉ
            <br />
          </strong>
        </p>
        <p>
          La présente politique de confidentialité peut être consultée à tout
          moment à l'adresse ci-après indiquée&nbsp;:
        </p>
        <p>
          <span id="span_id_adresse_politique_confidentialite">
            <span className="variable_vide">________</span>
          </span>
        </p>
        <p>
          L'éditeur du site se réserve le droit de la modifier afin de garantir
          sa conformité avec le droit en vigueur.
        </p>
        <p>
          Par conséquent, l'utilisateur est invité à venir consulter
          régulièrement cette politique de confidentialité afin de se tenir
          informé des derniers changements qui lui seront apportés.
        </p>
        <p>
          Il est porté à la connaissance de l'utilisateur que la dernière mise à
          jour de la présente politique de confidentialité est intervenue
          le&nbsp;: ___ / ___ / __________.
        </p>
        <p>
          <strong>
            <br />
            ARTICLE 8&nbsp;:{' '}
            <span className="flou">
              88852585588 288 2'55525585558 85 28 282555555 85 888258585582555
            </span>
            <br />
          </strong>
        </p>
        <p>
          <span className="flou">
            52 258825522 855 82 8822, 8'52888852255 5222822 58285 85 22 8222588
            85 25282222 228828852 52 822285222858822 22 22 5882222 828
            8225828228, 22 82 858 82282522 2858 2552885882522222 85 82882822 22
            82 2558222222 52 828 5222228 5 855582252 225822228
          </span>
          , ainsi que l'utilisation de fichiers "cookies".
        </p>
      </div>
    </section>
  );
}

export default Privacy;
